<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Credit Note</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" :reverse-transition="false">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="creditNoteMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="creditNoteFormLabel.docAE" v-model="creditNoteForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.transactionDate }}</v-subheader>
                              <div class="queryValue">{{ convertDate(creditNoteForm.transactionDate) }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.accountNo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md3 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.accountNoSuffix }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatusList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.amountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(creditNoteForm.gstAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="creditNoteFormLabel.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(creditNoteForm.netAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.netLocalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(creditNoteForm.netLocalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox
                                color="primary"
                                :label="creditNoteFormLabel.netAmountLocalAE"
                                v-model="creditNoteForm.netAmountLocalAE"
                                disabled
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.netLocalAmount }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.netLocalAmount }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.createdBy + ' on ' + creditNoteForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.modifiedBy + ' on ' + creditNoteForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="creditNoteOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocumentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.details }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.statementRef }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.statementRef }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>

            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
            <!-- CBO Added: Oct-05-2020 Comments -->
            <v-layout row wrap>
              <v-flex lg12 xs12 order-lg1 order-xs2>
                <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :mode="'query'"></common-comments>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when review Credit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { creditNoteAjaxMixin } from '@/mixins/accounting/creditNote/creditNoteAjaxMixin'
import { creditNoteViewMixin } from '@/mixins/accounting/creditNote/creditNoteViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      tabNav: 0,
      acctNoSfxApplnInt: '60',
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      accounts: [],
      accountdata: {},
      acctnosuffixes60: [],
      amountcurrencies: [],
      amountcurrencydata: {},
      departments: [],
      miscacctparams: [],
      funds: [],
      currencies: [],
      isMandatory: true,
      isOptional: false,
      trandaterange: {},
      gstStatuses: [],
      gstrate: '0.00',
      baseCurrency: ''
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    creditNoteData() {
      return this.$store.state.creditNote.creditNoteData
    },
    displayErrorDialog() {
      return this.messages
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.creditNoteForm.branch
      })
    },
    filterAccountNoList() {
      return this.accounts.filter((list) => {
        return list.value === this.creditNoteForm.accountNo
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.creditNoteForm.fund
      })
    },
    filterAccountNoSuffixList() {
      return this.acctnosuffixes60.filter((list) => {
        return list.value === this.creditNoteForm.accountNoSuffix
      })
    },
    filterGstIOList() {
      return this.gstIO.filter((list) => {
        return list.value === this.creditNoteForm.gstIO
      })
    },
    filterGstStatusList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.creditNoteForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.creditNoteForm.amountCurr
      })
    },
    filterPrintDocumentList() {
      return this.printDocOpts.filter((list) => {
        return list.value === this.creditNoteForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOpts.filter((list) => {
        return list.value === this.creditNoteForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.creditNoteForm.department
      })
    },
    apiURI() {
      return this.$store.state.creditNote.menu
    },
    commentRefNo() {
      const data = this.$store.state.creditNote.creditNoteData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.creditNote.creditNoteData.type
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('creditNoteInit')])
      this.fetchBranch()
      this.fetchAccount()
      this.fetchAcctNoSfx60()
      this.fetchAmountCurrency()
      this.fetchFund()
      this.fetchDepartment()
      this.fetchGstStatus()
      this.fetchCurrency()
      await Promise.all([this.performReview()])
    },
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doMandatory(tabId) {
      this.isMandatory = true
      this.isOptional = false
      this.validStatus.optional = true
      this.validStatus.mandatory = true
      this.tabNav = tabId
    },
    doOptional(tabId) {
      this.isMandatory = false
      this.isOptional = true
      this.validStatus.mandatory = true
      this.validStatus.optional = true
      this.tabNav = tabId
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doCancel() {
      this.$router.push({ name: 'creditNote' }).catch(() => {})
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, creditNoteAjaxMixin, creditNoteViewMixin, commonAjaxMixin],
  components: {
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
